import { render, staticRenderFns } from "./appList.vue?vue&type=template&id=0a674ed1&"
import script from "./appList.vue?vue&type=script&lang=js&"
export * from "./appList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports